import { useEffect, useState } from 'react';

import { useReportStore } from '../../providers';
import { SectionHeader, SectionSubHeader } from '../Card';
import ReportGrid from './ReportGrid';

export function PropertyInputs() {
  const { location, purchase, revenue, expenses, growthRates } = useReportStore();

  const [_location, setLocation] = useState(location);
  const [_purchase, setPurchase] = useState(purchase);
  const [_revenue, setRevenue] = useState(revenue);
  const [_expenses, setExpenses] = useState(expenses);
  const [_growthRates, setGrowthRates] = useState(growthRates);

  useEffect(() => {
    setRevenue(revenue);
    setLocation(location);
    setExpenses(expenses);
    setPurchase(purchase);
    setGrowthRates(growthRates);
  }, [revenue, location, expenses, purchase, growthRates]);

  return (
    <>
      <SectionHeader>Inputs</SectionHeader>
      <SectionSubHeader>Location</SectionSubHeader>
      <ReportGrid data={_location}></ReportGrid>
      <SectionSubHeader>Purchase Information</SectionSubHeader>
      <ReportGrid data={_purchase}></ReportGrid>
      <SectionSubHeader>Revenue</SectionSubHeader>
      <ReportGrid data={_revenue}></ReportGrid>
      <SectionSubHeader>Expenses</SectionSubHeader>
      <ReportGrid data={_expenses}></ReportGrid>
      <SectionSubHeader>Growth Rates</SectionSubHeader>
      <ReportGrid data={_growthRates}></ReportGrid>
    </>
  );
}

export default PropertyInputs;
